import { render, staticRenderFns } from "./gift-banner-row.vue?vue&type=template&id=6b55e43d&scoped=true&"
import script from "./gift-banner-row.vue?vue&type=script&lang=js&"
export * from "./gift-banner-row.vue?vue&type=script&lang=js&"
import style0 from "./gift-banner-row.vue?vue&type=style&index=0&id=6b55e43d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b55e43d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b55e43d')) {
      api.createRecord('6b55e43d', component.options)
    } else {
      api.reload('6b55e43d', component.options)
    }
    module.hot.accept("./gift-banner-row.vue?vue&type=template&id=6b55e43d&scoped=true&", function () {
      api.rerender('6b55e43d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/pageParts/gift-banner-row.vue"
export default component.exports